var _g, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardimage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 283,
    viewBox: "0 0 282 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_438_871)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 0.875,
    width: 274,
    height: 274,
    rx: 30,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_438_871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.666 159.718V113.259C142.666 112.059 141.693 111.087 140.494 111.087C139.295 111.087 138.322 112.059 138.322 113.259V159.718C138.322 160.917 139.295 161.89 140.494 161.89C141.693 161.89 142.666 160.917 142.666 159.718Z",
    fill: "#5444F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.929 159.707C191.929 160.907 190.957 161.879 189.757 161.879C188.558 161.879 187.586 160.907 187.586 159.707V150.455C187.586 144.145 182.471 139.03 176.161 139.03H104.836C98.5267 139.03 93.4118 144.145 93.4118 150.455V159.707C93.4118 160.907 92.4395 161.879 91.2401 161.879C90.0407 161.879 89.0684 160.907 89.0684 159.707V148.283C89.0684 140.774 95.1555 134.687 102.664 134.687H178.333C185.842 134.687 191.929 140.774 191.929 148.283V159.707Z",
    fill: "#5444F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.317 186.054C156.317 194.791 149.235 201.873 140.5 201.873H140.498C131.764 201.873 124.682 194.791 124.682 186.056V186.054C124.682 177.32 131.764 170.238 140.498 170.238H140.5C149.235 170.238 156.317 177.319 156.317 186.054Z",
    fill: "#F39A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.994 186.057C209.994 194.793 202.912 201.875 194.178 201.875H194.176C185.441 201.875 178.359 194.793 178.359 186.059V186.057C178.359 177.322 185.441 170.24 194.176 170.24H194.178C202.912 170.24 209.994 177.322 209.994 186.057Z",
    fill: "#E5594F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.641 186.057C102.641 194.793 95.5592 201.875 86.8247 201.875H86.8225C78.0878 201.875 71.0059 194.793 71.0059 186.059V186.057C71.0059 177.322 78.0878 170.24 86.8223 170.24H86.8244C95.5592 170.24 102.641 177.322 102.641 186.057Z",
    fill: "#4A5699"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.182 92.2453V88.2406C153.699 84.5508 155.993 76.2744 152.301 69.7571C148.611 63.2399 140.335 60.9466 133.817 64.6386C127.3 68.3305 125.007 76.6048 128.699 83.122C129.911 85.261 131.678 87.0311 133.817 88.2409V92.2455C121.178 92.8363 114.752 101.382 114.752 107.126V111.843H166.247V107.126C166.248 101.382 159.828 92.836 147.182 92.2453Z",
    fill: "#4A5699"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_438_871",
    x: -19,
    y: -18.125,
    width: 318,
    height: 318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_438_871"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_438_871",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -23,
    dy: -19
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_438_871"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 21,
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.443137 0 0 0 0 0.443137 0 0 0 0 0.443137 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_438_871",
    result: "effect3_innerShadow_438_871"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_438_871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 139,
    fill: "white",
    transform: "translate(71 62.875)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardimage3);
export default __webpack_public_path__ + "static/media/cardimage3.9499c81a3f641b98afca3d0a29219224.svg";
export { ForwardRef as ReactComponent };